common.View.create('canvas.blocks.custom.contentBlog.Block', {

    onDOMLoad() {

        this.initSlider();
    },

    initSlider() 
    {
        this.element.find('.owl-carousel').owlCarousel({
            loop: false,
            nav: true,
            dots: false,
            autoplay: false,
            // autoplayTimeout:2500,
            // autoplayHoverPause:true,
            navContainer: this.element.find('.owl-carousel-nav').get(0),
            navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
            responsive: {
                320: {
                    items: 1
                },
                640: {
                    items: 2
                },
                1000: {
                    items: 3
                },
            }
        });

    }
});
